import { GOOGLE_FONTS_URL, FONT_FAMILY, FONT_FAMILY_DISPLAY, FONT_FAMILY_MONO } from "../constants/typography.js";

(() => {
  if (document.getElementById("nemo-css")) return;
  if (!document.getElementById("nm-app-fonts") && !document.querySelector('link[href*="fonts.googleapis.com/css2"]')) {
    const l = document.createElement("link");
    l.id = "nm-app-fonts";
    l.rel = "stylesheet";
    l.href = GOOGLE_FONTS_URL;
    document.head.appendChild(l);
  }
  const s = document.createElement("style");
  s.id = "nemo-css";
  s.textContent = `
    @keyframes fade-up { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
    @keyframes tooltip-in { from{opacity:0;transform:translateX(-4px)} to{opacity:1;transform:translateX(0)} }
    @keyframes skeleton-pulse { 0%,100%{opacity:.45} 50%{opacity:.85} }
    .nemo-section-items { overflow:hidden; transition:max-height .28s cubic-bezier(.4,0,.2,1), opacity .2s; }
    .nemo-tooltip { animation: tooltip-in .14s ease; }
    .nemo-popover { animation: fade-up .18s ease; }
    .nemo-sidebar { transition: width .25s cubic-bezier(.4,0,.2,1), min-width .25s cubic-bezier(.4,0,.2,1); }
    .nemo-collapse-btn { transition: transform .25s cubic-bezier(.4,0,.2,1); }
    .nemo-main-route { animation: fade-up .28s cubic-bezier(.2,.85,.2,1); }
    .nemo-skeleton-cell { animation: skeleton-pulse 1.2s ease-in-out infinite; }
    html, body { margin:0; padding:0; font-family: var(--nm-font, ${FONT_FAMILY}); }
    :root {
      --nm-font-display: ${FONT_FAMILY_DISPLAY};
      --nm-font-mono: ${FONT_FAMILY_MONO};
    }
    button { font-family: inherit; }
    * { box-sizing: border-box; }
  `;
  document.head.appendChild(s);
})();
